import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "@progress/kendo-react-indicators";
import RefreshIcon from "../../../assets/header/refresh.svg";
import ExportIcon from "../../../assets/header/export.svg";
import {
  deleteSurveyById,
  fetchAllPollSurvey,
  updatePollSurveyStatus
} from "../../../store/poll_and_survey";
import "./poll_and_survey.css";
import { useLocation, useNavigate } from "react-router";
import { TableHeader } from "../../../components/reusableItems/header";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import {
  checkPermission,
  getUserPermission,
} from "../../../config/permission_helper";
import moment from "moment";
import { fetchUserById } from "../../../store/userMgmt";
import { POLL_SURVEY_ADD, POLL_SURVEY_DETAIL } from "../../../routes";
import { Reusable_table } from "../../../components/reusableItems/table";
import {
  ConfigData,
  DefaulSorting,
  statusConfig,
  statusConfigForApprove,
  statusConfigForPublishScheduled,
  statusConfigForPending
} from "./configData";
import { ShowDialog } from "../../../components/reusableItems/dialog";
import { Dialog } from "@progress/kendo-react-dialogs";
export const POLL_SURVEY_TABS = {
  ALL: "All",
  PUBLISHED: "Published",
  CONCLUDED: "Concluded",
  PENDING_APPROVAL: "Pending Approval",
  DRAFT: "Draft",
  CLOSED: "Closed",
  SCHEDULED: "Scheduled",
};

export const PollSurveyListing = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { searchQuery } = useLocation();
  const query = new URLSearchParams(searchQuery);
  const { poll_survey_list } = useSelector(
    (state) => state.pollSurvey
  );
  const [tab, setTab] = useState(POLL_SURVEY_TABS.ALL);
  const [tempData, setTempData] = useState([]);
  const [tabStatus, setTabStatus] = useState("");

  const [loading, setLoading] = useState([]);
  const [showUpdateStatus, setShowUpdateStatus] = useState(false);
  const [tempStatus, setTempStatus] = useState("");
  const [tempOldStatus, setTempOldStatus] = useState("");
  const [tempStatusData, setTempStatusData] = useState([]);
  const [tempStartDate, setTempStartDate] = useState("");
  const [tempEndDate, setTempEndDate] = useState("");

  const [tempDate, setTempDate] = useState("");

  const [tempId, setTempId] = useState("");
  const [actionID, setActionID] = useState("");
  const [actionType, setActionType] = useState("");
  const [timeChange, setTimeChange] = useState(false);
  const [showEndDateError, setShowEndDateError] = useState(false);
  const [showPublishDialog, setShowPublishDialog] = useState(false);

  const [showDelete, setShowDelete] = useState(false);


  const userPermissions = getUserPermission();
  const AddPermssion = checkPermission(
    userPermissions,
    "survey.submit_survey"
  ) || false;

  const viewPermssion = checkPermission(
    userPermissions,
    "survey.access_survey_polls"
  );

  const getData = async (status, callback) => {
    setLoading(true);
    dispatch(fetchUserById(localStorage.getItem("username"))).then(
      async (result) => {

        dispatch(fetchAllPollSurvey({ status: status })).then((res) => {
          setLoading(false);
          const formatToSGT = (dateString) => {
            // Check if already formatted
            if (dateString.includes('+08:00')) return dateString;
            return `${dateString}.000+08:00`;
          };

          const formattedData = res.payload.data.map(item => ({
            ...item,
            publish_on: formatToSGT(item.publish_on),
            publish_end: formatToSGT(item.publish_end),
          }));

          setTempData(formattedData);
        });
      }
    );
  };

  useEffect(() => {
    getData(tabStatus);
  }, [tab]);


  const actionTrigger = () => {
    setLoading(true);
    if (actionType === "Delete") {
      setShowDelete(false);

      dispatch(deleteSurveyById(actionID)).then((res) => {
        getData(tabStatus);
      });
    }
  };



  const handleTableClick = (type, id) => {
    if (type === "View Details") {
      navigate(`${POLL_SURVEY_DETAIL}?id=${id}`);
    } else if (type === "Delete") {
      setActionID(id);
      setActionType(type);
      if (type === "Delete") {
        setShowDelete(true);
      }
    }
    else if (type == "Edit") {
      navigate(`${POLL_SURVEY_ADD}?id=${id}`);
    }
    else {
      const survey = tempData.find(survey => survey.id === id);
      const surveyDetail = tempData.find(temp => temp.id === id);
      setTempDate(moment());

      const currentIndex = statusConfig.findIndex(status => status.name === survey.status);

      const nextStatuses = currentIndex !== -1 ? statusConfig.slice(currentIndex + 1) : [];

      setTempStatusData(nextStatuses);
      if (survey.status == "Published" || survey.status == "Scheduled") {
        setTempStatusData(statusConfigForPublishScheduled)
      }
      if (survey.status == "Approved") {
        setTempStatusData(statusConfigForApprove);
      }
      if (survey.status == "Pending Approval") {
        setTempStatusData(statusConfigForPending);
      }
      setTempId(survey.id);
      setTempStatus(survey.status);
      setTempOldStatus(survey.status);
      setTempStartDate(surveyDetail.publish_on);
      setTempEndDate(surveyDetail.publish_end);

      setShowUpdateStatus(true);


    }
  };

  const RefreshData = () => {
    getData(tabStatus);
  };




  const handleCreateAction = () => {
    navigate(POLL_SURVEY_ADD);
  };

  const icons = [
    ...(AddPermssion ? [{
      buttonName: "+ Add new",
      action: handleCreateAction,
    }] : []),
    {
      icon: RefreshIcon,
      title: "Refresh",
      action: RefreshData,
    },
    // {
    //   icon: ExportIcon,
    //   title: "Export",
    //   action: handleExport,
    // },
  ];

  const updateStatus = () => {
    setTimeChange(false);
    setTempStartDate("");
    setShowPublishDialog(false);

    const getstatus = statusConfig.find(status => status.name === tempStatus);

    let params = { question_id: tempId, status: getstatus.id, updated_on: tempDate.format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ") };
    setTempId("");
    setTempStatus("");
    setShowUpdateStatus(false);
    dispatch(updatePollSurveyStatus(params)).then((res) => {
      if (res.payload.status_code === 200) {
        getData(tabStatus);
      } else {
        alert(res.payload.message);
      }
    });
  };

  const checkTimeForPublish = () => {
    setTempDate(moment());

    if (tempStatus == "Published") {
      const isPassed = moment().isAfter(moment(tempStartDate));

      if (isPassed) {
        setTimeChange(true);

      } else {
        setShowPublishDialog(true);
      }

    } else {
      updateStatus();
    }
  }

  const checkEndDateForPublish = () => {
    const isPassed = moment().isAfter(moment(tempEndDate));

    if (isPassed) {
      setShowEndDateError(true);
    } else {
      updateStatus();
    }
  }





  const onTabChange = (tab) => {
    setTab(tab);
  };


  const getTime = () => {
    return tempDate.format('DD-MMM-YYYY hh:mm A');
  }


  return (
    <>
      {viewPermssion ? (
        <div className="container">

          {showEndDateError && (
            <Dialog
              className="alert-form"
              title={"Alert"}
              width={400}
              // height={280}
              onClose={() => setShowEndDateError(false)}
            >
              <p>End Date cannot be earlier than Start Date!</p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "30px",
                    borderRadius: "10px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setShowEndDateError(false)
                    navigate(`${POLL_SURVEY_ADD}?id=${tempId}`);
                  }}
                >
                  Change
                </div>
              </div>
            </Dialog>
          )}

          {timeChange && (
            <Dialog
              className="alert-form"
              title={"Alert"}
              width={400}
              // height={280}
              onClose={() => setTimeChange(false)}
            >
              <p>
                The selected publishing time has already passed. Could we proceed by
                submitting the new publish time for {getTime()}?
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "30px",
                    borderRadius: "10px",
                    background: "white",
                    color: "#eb6e1f",
                    cursor: "pointer",
                    border: "1px solid #eb6e1f",
                  }}
                  onClick={() => {
                    setTimeChange(false);
                    setTempStartDate("");
                  }}
                >
                  Go back
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "30px",
                    borderRadius: "10px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => checkEndDateForPublish()}
                >
                  Submit
                </div>
              </div>
            </Dialog>
          )}


          {showPublishDialog && (
            <Dialog
              className="alert-form"
              title={"Manual Publish Confirmation"}
              width={400}
              // height={280}
              onClose={() => setShowPublishDialog(false)}
            >
              <p>
                You've configured a Start Date and Time for this Polls & Surveys.
                By manually publishing now, the Start Date and Time will be updated to the current time. The End Date and Time will remain unchanged.
              </p>
              <p>Do you want to continue?</p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "30px",
                    borderRadius: "10px",
                    background: "white",
                    color: "#eb6e1f",
                    cursor: "pointer",
                    border: "1px solid #eb6e1f",
                  }}
                  onClick={() => {
                    setTimeChange(false);
                    setTempStartDate("");
                    setShowPublishDialog(false);
                  }}
                >
                  Cancel
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "30px",
                    borderRadius: "10px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => updateStatus()}
                >
                  Publish Now
                </div>
              </div>
            </Dialog>
          )}

          {showUpdateStatus && (
            <ShowDialog
              cancelbtn={() => {
                setShowUpdateStatus(false);
                setTempStatus("");
              }}
              title={"Update Status"}
              dropdownContent={"Set status"}
              dropdown={true}
              cancelContent={"Cancel"}
              confrimContent={"Update"}
              isDisabled={tempStatus == tempOldStatus}
              confrinbtn={checkTimeForPublish}
              dropdownData={tempStatusData.map(status => status.name)}
              dropdownOnChange={(e) => setTempStatus(e)}
              dropdownValue={tempStatus}
            />
          )}

          <TableHeader title={"Polls & Surveys"} icons={icons} />
          {showDelete && (
            <ShowDialog
              title={"Please Confirm!"}
              content={"Are you sure you want to delete?"}
              cancelContent={"Cancel"}
              confrimContent={"Delete"}
              cancelbtn={() => setShowDelete(false)}
              confrinbtn={actionTrigger}
            />
          )}

          {(<div className="poll_and_survey_child_box_main_detail_box">
            <div>
              <div className="tabs">
                <div
                  onClick={() => {
                    onTabChange(POLL_SURVEY_TABS.ALL);
                    getData();
                  }}
                  className={`tab ${tab === POLL_SURVEY_TABS.ALL ? "isactive" : ""
                    }`}
                >
                  {POLL_SURVEY_TABS.ALL}
                </div>
                <div style={{ borderLeft: "2px solid #CCCCCC" }}></div>

                <div
                  onClick={() => {
                    onTabChange(POLL_SURVEY_TABS.DRAFT);
                    setTabStatus("draft");

                  }}
                  className={`tab ${tab === POLL_SURVEY_TABS.DRAFT ? "isactive" : ""
                    }`}
                >
                  {POLL_SURVEY_TABS.DRAFT}
                </div>

                <div style={{ borderLeft: "2px solid #CCCCCC" }}></div>

                <div
                  onClick={() => {
                    onTabChange(POLL_SURVEY_TABS.PENDING_APPROVAL);
                    setTabStatus("pendingapproval");
                  }}
                  className={`tab ${tab === POLL_SURVEY_TABS.PENDING_APPROVAL ? "isactive" : ""
                    }`}
                >
                  {POLL_SURVEY_TABS.PENDING_APPROVAL}
                </div>

                <div style={{ borderLeft: "2px solid #CCCCCC" }}></div>
                <div
                  onClick={() => {
                    onTabChange(POLL_SURVEY_TABS.SCHEDULED);
                    setTabStatus("scheduled");


                  }}
                  className={`tab ${tab === POLL_SURVEY_TABS.SCHEDULED ? "isactive" : ""
                    }`}
                >
                  {POLL_SURVEY_TABS.SCHEDULED}
                </div>


                <div style={{ borderLeft: "2px solid #CCCCCC" }}></div>

                <div
                  onClick={() => {
                    onTabChange(POLL_SURVEY_TABS.PUBLISHED);
                    setTabStatus("published");

                  }}
                  className={`tab ${tab === POLL_SURVEY_TABS.PUBLISHED ? "isactive" : ""
                    }`}
                >
                  {POLL_SURVEY_TABS.PUBLISHED}
                </div>

                <div style={{ borderLeft: "2px solid #CCCCCC" }}></div>
                <div
                  onClick={() => {
                    onTabChange(POLL_SURVEY_TABS.CONCLUDED);
                    setTabStatus("concluded");

                  }}
                  className={`tab ${tab === POLL_SURVEY_TABS.CONCLUDED ? "isactive" : ""
                    }`}
                >
                  {POLL_SURVEY_TABS.CONCLUDED}
                </div>

                <div style={{ borderLeft: "2px solid #CCCCCC" }}></div>


                <div
                  onClick={() => {
                    onTabChange(POLL_SURVEY_TABS.CLOSED);
                    setTabStatus("closed");


                  }}
                  className={`tab ${tab === POLL_SURVEY_TABS.CLOSED ? "isactive" : ""
                    }`}
                >
                  {POLL_SURVEY_TABS.CLOSED}
                </div>



              </div>
            </div>

            {loading ? (
              <Loader
                type="converging-spinner"
                style={{
                  width: "100%",
                  height: "calc(100vh - 165px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#ffffff4d",
                  position: "absolute",
                  zIndex: "999",
                }}
              />
            ) : (
              <Reusable_table
                header={ConfigData}
                data={tempData}
                pagination={true}
                calculatePagi={true}
                pageChangeLoading={false}
                showRow={true}
                checkbox={false}
                //   handleTableClick={handleTableClick}
                handleAction={handleTableClick}
                maxHeight={"calc(-221px + 100vh)"}
                maxWidth={"calc(100vw - 240px)"}
              />
            )}
          </div>
          )}
        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
